import { Col, Layout, Row, Space, Typography } from "antd";
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "../context/themeContext";
import CustomHeader from "../components/common/Header";

const { Title } = Typography;
const ProviderPortal = () => {
  const { theme } = useContext(ThemeContext)
  const { Content, Footer } = Layout;

  return (
    <>
      <Layout className="bg-white">
       <CustomHeader />
        <Content className="p-4 pb-0 md:p-6">
          <div className="container mx-auto">
            <Row gutter={[10, 30]}>
              <Col span={24}>
                <Space direction="vertical" className="welcome-block" size={0}>
                  <Title level={4} className="text-black welcome-line">
                    {" "}
                    Welcome to the Provider1st Portal.
                  </Title>
                  <Title level={4} className="text-black welcome-sub-line">
                    {/* <Badge color="black" />{" "} */}
                    <span >
                      What type of request are you filing?
                    </span>
                  </Title>
                </Space>
              </Col>
              <Col span={24}>
                <Row gutter={[0, 0]}>
                  <Space
                    size={10}
                    align="baseline"
                    className={`tabs-container  w-full px-1 md:px-5 ${sessionStorage.getItem("IsFMLAEnabled").toLowerCase() === 'true' ? "justify-around" : "justify-center"}`}
                  >
                    <div className="tabs-wrapper m-0">
                      <Link to="/Welcome" className={`tabs-item ${theme}`}>
                        <Title level={2} className="text-white font-bold text-center">
                          Medical Records
                        </Title>
                      </Link>
                      <p className="mt-3 ps-1 !text-center md:!text-left">
                        Get a copy of medical, billing, and/or radiology records.
                      </p>
                    </div>
                    {sessionStorage.getItem("IsFMLAEnabled").toLowerCase() === 'true' &&
                      <div className="tabs-wrapper m-0">
                        <Link to="/Requirement" className={`tabs-item ${theme}`}>
                          <Title level={2} className="text-white font-bold text-center">
                            FMLA/Disability
                          </Title>
                        </Link>
                        <p className="mt-3 ps-1 !text-center md:!text-left">
                          Get FMLA or Disability paperwork completed.
                        </p>
                      </div>
                    }
                  </Space>
                </Row>
              </Col>
              <Col span={24} align="center">
                <Space direction="vertical" className="or-information">
                  <Space
                    direction="vertical"
                    size={0}
                    style={{ width: "100%" }}
                  >
                    <Title
                      level={4}
                      className="text-black font-normal information-sub-line"
                    >
                      <div className="px-4 mt-[40px] text-center">
                        {/* <Badge color="#000000" /> */}
                        <span>
                          If you have <u className="font-bold">ALL</u> the
                          required documents, you can{" "}
                          <u className="font-bold">email</u>  us at
                        </span>
                        <a className={`font-bold link ${theme}`} href="mailto:requests@provider1st.com"> requests@provider1st.com</a>{" "}
                        or <u className="font-bold">fax</u> us at{" "}
                        <u className={`${theme}-color font-bold`}>800-818-2114</u>{" "} and <u >skip</u> the online process.
                      </div>
                    </Title>
                  </Space>
                </Space>
              </Col>
            </Row>
            <Footer className="welcome-footer bg-white p-3 pl-0 md:pl-9">
              <Row>
                <Col span={24}>
                  <Title level={2} align="center" className="mt-[50px] !font-[600]">
                    If you need assistance with your request, please give us a call:
                    <u className={`${theme}-color ml-1`}>855-514-2378</u>.
                  </Title>
                </Col>

              </Row>
            </Footer>
            <Row>
              <Col span={24} className="text-right">
                <Space direction="vertical" className="text-left" size={0} >
                  <span className="font-medium">Powered by</span>
                  <img src={window.location.origin + "/assets/images/Logo.svg"} />
                </Space>
              </Col>
            </Row>
          </div>
        </Content>
      </Layout>
    </>
  );
};

export default ProviderPortal;
